module.exports = __webpack_public_path__ + "static/compound_details_waves-e688d4f610448d66266a993474f93f76.svg";